package empiresmp.feature.shop.ui

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import com.varabyte.kobweb.compose.dom.ref
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.forms.TextInput
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.common.PlaceholderColor
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.shapes.Rect
import com.varabyte.kobweb.silk.theme.shapes.clip
import empiresmp.components.FlowRow
import empiresmp.components.LoadingIndicator
import empiresmp.components.Spacer
import empiresmp.components.layouts.PageLayout
import empiresmp.components.navbar.EmpireSmpDesktopNavBar
import empiresmp.feature.shop.backend.model.ShopItemType
import empiresmp.feature.shop.viewmodel.ShopViewModel
import kotlinx.browser.localStorage
import kotlinx.coroutines.flow.filterIsInstance
import kotlinx.coroutines.flow.first
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.w3c.dom.get
import org.w3c.dom.set
import ru.astrainteractive.kobwebx.core.theme.composable.LocalSitePalette
import ru.astrainteractive.kobwebx.core.theme.util.ThemeExt.typography

@Composable
@Suppress("LongMethod")
fun ShopPageContent() {
    val theme = LocalSitePalette.current
    val ctx = rememberPageContext()
    val shopViewModel = ShopViewModel(
        initialUsername = ctx.route.queryParams["username"].orEmpty()
    )
    LaunchedEffect(Unit) {
        val storageUsername = localStorage["username"] ?: return@LaunchedEffect
        val loaded = shopViewModel.state
            .filterIsInstance<ShopViewModel.State.Loaded>()
            .first()
        val viewModelUsername = loaded.username
        if (!viewModelUsername.isEmpty()) return@LaunchedEffect
        shopViewModel.onUsernameChanged(storageUsername)
    }
    val state by shopViewModel.state.collectAsState()
    PageLayout {
        EmpireSmpDesktopNavBar()
        Column(modifier = Modifier.fillMaxSize()) {
            when (val localState = state) {
                ShopViewModel.State.Error -> {
                    Box(
                        modifier = Modifier.fillMaxSize()
                            .background(theme.colors.colorPrimaryVariant),
                        contentAlignment = Alignment.Center
                    ) {
                        SpanText(
                            text = "Не удалось загрузить предметы",
                            modifier = theme.typography.h3.toModifier()
                                .color(theme.colors.colorOnPrimary)
                        )
                    }
                }

                is ShopViewModel.State.Loading -> {
                    Box(
                        modifier = Modifier.fillMaxSize()
                            .background(theme.colors.colorPrimaryVariant),
                        contentAlignment = Alignment.Center
                    ) {
                        LoadingIndicator(Modifier.size(128.px))
                    }
                }

                is ShopViewModel.State.Loaded -> {
                    Column(
                        modifier = Modifier.fillMaxSize().background(theme.colors.colorPrimaryVariant),
                        horizontalAlignment = Alignment.CenterHorizontally,
                        verticalArrangement = Arrangement.Top
                    ) {
                        Column(
                            modifier = Modifier
                                .width(50.percent)
                                .clip(Rect(theme.dimens.S))
                                .background(theme.colors.colorPrimary)
                                .padding(theme.dimens.S),
                            horizontalAlignment = Alignment.CenterHorizontally,
                            verticalArrangement = Arrangement.spacedBy(theme.dimens.S)
                        ) {
                            SpanText(
                                text = "Пожалуйста, введите ваш ник в игре:",
                                modifier = theme.typography.h2.toModifier()
                                    .color(theme.colors.colorError)
                            )
                            TextInput(
                                text = localState.username,
                                onTextChange = {
                                    localStorage["username"] = it
                                    shopViewModel.onUsernameChanged(it)
                                },
                                placeholder = "Ваш ник в игре",
                                placeholderColor = PlaceholderColor(theme.colors.colorHintOnPrimary),
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .color(theme.colors.colorOnPrimary),
                                ref = ref { it.focus() },
                                onCommit = {}
                            )
                        }

                        localState.shop.shopItemDatas.groupBy {
                            when (it.type) {
                                ShopItemType.ITEM_STACK -> "Предметы"
                                ShopItemType.COMMAND -> "Команды"
                                ShopItemType.PERMISSION -> "Права"
                                ShopItemType.MONEY -> "Деньги"
                                ShopItemType.JUST_DONATE -> "Просто поддержать"
                                ShopItemType.UNBAN -> "Разбан"
                            }
                        }.map { it.key to it.value }.forEach { (k, shopItems) ->
                            Column(
                                verticalArrangement = Arrangement.spacedBy(theme.dimens.L),
                                horizontalAlignment = Alignment.CenterHorizontally
                            ) {
                                SpanText(
                                    text = k,
                                    modifier = theme.typography.h3.toModifier()
                                        .color(theme.colors.colorOnPrimary)
                                )
                                FlowRow {
                                    shopItems.forEach { data ->
                                        ShopItemCard(
                                            itemData = data,
                                            onClick = {
                                                shopViewModel.onSelectedItemChanged(data.id)
                                            }
                                        )
                                    }
                                }
                                Spacer()
                            }
                        }
                    }

                    ConfirmDialog(
                        username = localState.username,
                        onDismiss = { shopViewModel.onSelectedItemChanged(null) },
                        onConfirm = { shopViewModel.onConfirm() },
                        itemState = localState.selectedItemState
                    )
                }
            }
        }
    }
}
